import PageCheckedHome from 'components/organisms/PageCheckedHome';
import PageCheckerIsOnboarded from 'components/organisms/PageCheckerIsOnboarded';
import { UserInformationProvider } from 'contexts/userContext';
import OnboardingLayout from 'layouts/onboarding-layout/onboarding-layout';
import OrdersLayout from 'layouts/orders-layout/orders-layout';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ChargeSettings } from 'views/charge-settings';
import ContactEdit from 'views/contacts/contact-edit/contact-edit';
import Contacts from 'views/contacts/contacts/contacts';
import { DocumentRequest } from 'views/document-request/document-request';
import { DocumentsTemplates } from 'views/documents-templates/documents-templates';
import { Orders } from 'views/index/orders';
import NotFound from 'views/not-found/not-found';
import OnboardingTermsAndConditions from 'views/onboarding/onboarding-terms-and-conditions/onboarding-terms-and-conditions';
import OnboardingWelcome from 'views/onboarding/onboarding-welcome/onboarding-welcome';
import SignIn from 'views/sign-in/sign-in';
import TermsOfService from 'views/terms-of-service/terms-of-service';
import Unsuscribe from 'views/unsuscribe/unsuscribe';

import ResetPassword from '../views/reset-password/reset-password';
import { PrivateRoute } from './PrivateRoute';
import EmailTemplates from 'views/email-templates/email-templates';
import { InferenceView } from 'views/inference';
import { ImportsView } from 'views/imports';
import { ImportsGate } from 'views/imports/imports-gate';
import Roles from 'views/roles/Roles';
import { PublicRoute } from './PublicRoute';
import OAuthCallback from 'views/oauth/oauth-callback';
import OAuthStart from 'views/oauth/oauth-start';
import { AiConfigProvider } from 'views/ai-config/context';
import { AiConfigScreen } from 'views/ai-config';

const RootRoutes = () => (
  <>
    <Switch>
      <PrivateRoute exact path="/contacts" protectedRoute>
        <Contacts />
      </PrivateRoute>

      <PrivateRoute exact path="/document-templates" protectedRoute>
        <DocumentsTemplates />
      </PrivateRoute>

      <PrivateRoute exact path="/email-templates" protectedRoute>
        <EmailTemplates />
      </PrivateRoute>

      <PrivateRoute exact path="/roles" protectedRoute>
        <Roles />
      </PrivateRoute>

      <PrivateRoute exact path="/contacts/:id" protectedRoute>
        <ContactEdit />
      </PrivateRoute>

      <PrivateRoute exact path="/orders">
        <Orders />
      </PrivateRoute>

      <PrivateRoute path="/orders/details/:id?">
        <OrdersLayout />
      </PrivateRoute>

      <PrivateRoute path="/terms-of-service">
        <TermsOfService />
      </PrivateRoute>

      <PrivateRoute exact path="/charge-settings" protectedRoute>
        <ChargeSettings />
      </PrivateRoute>

      <PrivateRoute exact path="/ai-config" protectedRoute>
        <AiConfigProvider>
          <AiConfigScreen />
        </AiConfigProvider>
      </PrivateRoute>

      <PrivateRoute exact path="/inference">
        <InferenceView />
      </PrivateRoute>

      <PrivateRoute exact path="/imports">
        <ImportsGate>
          <ImportsView />
        </ImportsGate>
      </PrivateRoute>

      <Route
        exact
        path="/onboarding/terms-and-conditions"
        render={() => (
          <UserInformationProvider>
            <PageCheckerIsOnboarded
              render={() => (
                <OnboardingLayout>
                  <OnboardingTermsAndConditions />
                </OnboardingLayout>
              )}
            />
          </UserInformationProvider>
        )}
      />

      <Route
        exact
        path="/onboarding/welcome"
        render={() => (
          <UserInformationProvider>
            <PageCheckerIsOnboarded
              render={() => (
                <OnboardingLayout>
                  <OnboardingWelcome />
                </OnboardingLayout>
              )}
            />
          </UserInformationProvider>
        )}
      />

      <Route exact path="/" render={() => <PageCheckedHome />} />

      <Route exact path="/oauth/callback" render={() => <OAuthCallback />} />
      <Route exact path="/oauth/start" render={() => <OAuthStart />} />

      <Route exact path="/document_request/:token?" render={() => <DocumentRequest />} />
      <Route exact path="/unsubscribe/:token?" render={() => <Unsuscribe />} />

      <PublicRoute exact path="/sign-in">
        <SignIn />
      </PublicRoute>

      <Route exact path="/reset-password" render={() => <ResetPassword />} />

      <Route path="*" render={() => <NotFound />} />
    </Switch>
  </>
);

export default RootRoutes;
